import { color, layout, space, system, typography, variant } from 'styled-system';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import StyledSystemPropTypes from '@styled-system/prop-types';

const baseTextStyles = css`
  font-family: ${({ theme }) => theme.fonts.body};
  font-weight: ${({ theme }) => theme.fontWeights.normal};
  line-height: ${({ theme }) => theme.lineHeights.normal};
`;

const textDecoration = system({
  textDecoration: true,
});

const textTransform = system({
  textTransform: true,
});

const textVariants = variant({
  scale: 'text',
  variants: {
    body: {},
  },
});

const Text = styled.div`
  ${baseTextStyles};
  ${textVariants};
  ${textTransform};
  ${textDecoration};
  ${color};
  ${space};
  ${typography};
  ${layout};
`;

Text.defaultProps = {
  variant: 'body',
};

Text.propTypes = {
  variant: PropTypes.string,
  ...StyledSystemPropTypes.space,
  ...StyledSystemPropTypes.typography,
  ...StyledSystemPropTypes.color,
};

export { Text, textVariants, baseTextStyles };
